import React from 'react'
import NavPatient from '../../patients/navPatien/NavPatient'
import About from '../about/About'
import HeadBar from '../headBar/HeadBar'

function AboutPatient() {
    return (
        <div>
            <HeadBar />
            <About disabledMenu/>
        </div>
    )
}

export default AboutPatient